import { Divider } from '@mui/material'
import { RendererProps } from 'components/a2ui/types'
import { FC } from 'react'

type DividerRendererProps = Pick<RendererProps, 'component'>

/**
 * Renders a horizontal or vertical divider.
 */
export const DividerRenderer: FC<DividerRendererProps> = ({ component }) => {
    if (component.component.oneofKind !== 'divider') return null

    const div = component.component.divider

    return <Divider orientation={div.orientation === 'vertical' ? 'vertical' : 'horizontal'} />
}
